import {Dictionary} from '@/types'

type Obj = Dictionary

function parseKey(key: string, revert: boolean = false): string {
    return revert
        ? key.replace(/(_\w)/g, (v) => v[1].toUpperCase())
        : key.replace(/([^A-Z][A-Z])/g, (v) => `${v[0]}_${v[1].toLowerCase()}`)
}

function parseObject(object: Obj, revert: boolean = false): any {
    if (!object || 'object' !== typeof object) {
        return object
    }

    if (Array.isArray(object)) {
        return object.map((obj) => parseObject(obj, revert))
    }

    if (object.constructor !== {}.constructor) {
        return object
    }

    const parsedObj = {} as Obj

    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            parsedObj[parseKey(key, revert)] = parseObject(object[key], revert)
        }
    }

    return parsedObj
}

export function toUnderscore(obj: any): any {
    return parseObject(obj)
}

export function toCamelCase(obj: any): any {
    return parseObject(obj, true)
}
